import type { ReactNode } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { cn } from '@/lib/cn';

interface GetStartedTileProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  onClick?: () => void;
  className?: string;
}

export function GetStartedTile({ icon, title, subtitle, onClick, className }: GetStartedTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'surface-card-hover group flex min-h-16 min-w-0 items-center gap-3 rounded-xl border border-line-1 bg-bg-1 px-3.5 py-3 text-left',
        className,
      )}
    >
      <span className="flex size-9 shrink-0 items-center justify-center rounded-[10px] border border-line-1 bg-bg-0 text-text-2 transition-colors group-hover:border-violet/20 group-hover:bg-violet-soft group-hover:text-violet-deep">
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[13px] font-semibold text-text-1">{title}</div>
        <div className="truncate text-[12px] text-text-3">{subtitle}</div>
      </div>
      <span className="flex size-6 shrink-0 items-center justify-center text-text-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-violet-deep">
        <ArrowUpRight className="size-3.5" />
      </span>
    </button>
  );
}
